import { useSelector } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Field } from 'redux-form';

import { TextField, CheckBox } from 'common/components/forms';
import { getMessage } from 'common/helpers/miscHelper';

const Email = (props) => {
  const { match } = props;
  const { slug } = match.params;
  const settings = useSelector((state) => state.setting);
  return (
    <>
      <div className="c7-checkout__content__title">
        <h3>Contact information</h3>
        <Link to={`/club/${slug}/login`}>Already have an account? Log in</Link>
      </div>

      <Field
        name="email"
        component={TextField}
        label="Email"
        autocomplete="email"
        required
      />
      <Field
        name="isSubscribe"
        type="checkbox"
        component={CheckBox}
        label={getMessage('Subscribe Message', settings)}
        value="1"
      />
    </>
  );
};

export default withRouter(Email);
